import { SWITCH_BREAKPOINT } from './action-creators';
export default function (state = null, action, appShellData) {
    if (state === null) {
        state = appShellData.guessedBreakpoint;
    }
    switch (action.type) {
        case SWITCH_BREAKPOINT:
            return action.newBreakpoint;
        default:
            return state;
    }
}
